import { SwotDashboardGrid } from "@swot-shared/dashboard/index.js";
import { CmtsDashboardDrilldownLink } from "./CmtsDashboardDrilldownLink.js";

export type CmtsDashboardKpi = {
  readonly id?: string | undefined;
  readonly kpiCode?: string | undefined;
  readonly label?: string | undefined;
  readonly title?: string | undefined;
  readonly value?: string | number | null | undefined;
  readonly trend?: string | undefined;
  readonly description?: string | undefined;
  readonly filterPayload?: Record<string, string | number | boolean | undefined | null> | undefined;
};

export function CmtsKpiCardGrid(props: { readonly cards?: readonly CmtsDashboardKpi[] | null | undefined; readonly scope?: Record<string, string | number | boolean | undefined | null> | undefined; readonly readOnly?: boolean | undefined }) {
  const cards = props.cards ?? [];
  if (cards.length === 0) return <div className="cmts-empty-panel">No dashboard metrics were returned by backend for this scope.</div>;
  return (
    <SwotDashboardGrid>
      {cards.map((card, index) => {
        const key = String(card.kpiCode ?? card.id ?? `metric-${index}`);
        return (
          <CmtsDashboardDrilldownLink
            key={key}
            metricKey={key}
            label={String(card.label ?? card.title ?? key)}
            value={card.value ?? "Not available"}
            trend={card.trend}
            description={card.description}
            scope={{ ...(props.scope ?? {}), ...(card.filterPayload ?? {}) }}
            disabled={props.readOnly === false ? false : undefined}
          />
        );
      })}
    </SwotDashboardGrid>
  );
}
